import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { getArticleContent, getArticleMetadata } from '../utils/articleLoader';
import { SEO } from './SEO';
import { ArticleMetadata } from '../data/articlesMetadata';

export const Article: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [content, setContent] = useState('');
  const [metadata, setMetadata] = useState<ArticleMetadata | null>(null);

  useEffect(() => {
    const loadArticle = async () => {
      if (id) {
        const articleContent = await getArticleContent(id);
        const articleMetadata = await getArticleMetadata(id);
        setContent(articleContent);
        if (articleMetadata) {
          setMetadata(articleMetadata);
        }
      }
    };
    loadArticle();
  }, [id]);

  if (!metadata) return <div>Loading...</div>;

  return (
    <>
      <SEO 
        title={metadata.title}
        description={metadata.description}
        canonicalUrl={`/articles/${metadata.id}`}
        imageUrl={metadata.imageUrl}
      />
      <div className="about-container">
        <div className="about-content">
          <section className="bio">
            <Link to="/articles" className="back-link">← Back to Articles</Link>
            {metadata && (
              <div className="article-meta">
                <span className="article-category">{metadata.category}</span>
                <span className="article-date">{metadata?.date}</span>
              </div>
            )}
            <ReactMarkdown>{content}</ReactMarkdown>
          </section>
        </div>
      </div>
    </>
  );
};